export default __webpack_public_path__ + "static/media/default-view.916c259b.png";